// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".carousel-item[data-v-adf96590]{flex-shrink:0;width:100%;height:100%;min-height:0;background:#fff;position:relative;display:flex;justify-content:center;align-items:center}.discontinued-info[data-v-adf96590]{position:absolute;background-color:rgba(8,8,8,.50196);color:#fff;padding:5px 10px;z-index:1;font-size:18px;font-weight:400;width:100%;text-align:center;box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
